export { default } from './AreaSelect'


// WEBPACK FOOTER //
// ./src/modules/common/components/areaselect/index.js